import React from 'react';
import { CheckCircleFill } from 'react-bootstrap-icons';
import CareMapprButton from '../../../../components/Button/CareMapprButton';

const FinaliseButton = ({ onFinalise, disabled }) => {
  return (
    <CareMapprButton
      onClick={onFinalise}
      label="Finalise and send"
      endIcon={<CheckCircleFill />}
      contentAlign="center"
      disabled={disabled}
      style={{ width: '100%' }}
    />
  );
};

export default FinaliseButton;
